exports.ByIso = {
  CHN: true,
  IND: true,
  IDN: true,
  MEX: true
};
